import {mthen} from '@freckle/maybe'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import type {UnmanagedSummaryT} from '@freckle/school/ts/rostering/components/clean-up-roster/clean-up-phase'
import {Success} from '@freckle/school/ts/rostering/components/common/success'
import {UnmanagedStudents} from '@freckle/school/ts/rostering/components/common/unmanaged-students'

type Props = {
  unmanaged?: UnmanagedSummaryT
}

export function FinishedMerging({unmanaged}: Props) {
  const {t} = useSafeTranslation()

  const unmanagedStudents = mthen(unmanaged, summary => <UnmanagedStudents unmanaged={summary} />)

  return (
    <Success title={t('FINISHED_MERGING_DUPLICATE_STUDENTS_TITLE')}>{unmanagedStudents}</Success>
  )
}
